<template>
  <div class="main-history-container">
    <my-header :page_name="$t('navigation.headerTitles.history')" show_usermenu></my-header>
    <el-dialog
      width="75%"
      :visible.sync="modalOpen"
      center
      :title="selectedFileName"
      custom-class="more-info-dialog"
    >
      <div class="history-block more-info__inner">{{historyFile}}</div>
      <div class="bottom-buttons">
        <div></div>
        <el-button class="el-icon-download left" @click="saveToFile"> {{ $t('history.saveInFile') }} </el-button>
      </div>
    </el-dialog>
    <div class="settings-line">
      <div class="settings-element">
        <label>{{ $t('history.server') }}</label>
        <el-select v-model="serverSelected" @change="serverChanged" filterable>
          <el-option
            v-for="(server, index) in getServersArray"
            :key="index"
            :value="server.id"
            :label="server.name"
          ></el-option>
        </el-select>
      </div>
    </div>
    <el-tabs type="border-card" @tab-click="tabClick" v-model="selectedTab" v-if="cron&&cron.id">
      <el-tab-pane :label="$t('history.lastHistory')" name="lastHistory">
        <div class="main-last-history history-container">
          <!-- <div v-for="(line,index) in lastHistory" :key="index" class="last-history-block">{{line}}</div> -->
          <div class="last-history-block history-block">{{lastHistory}}</div>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('history.historyFilesList')" name="historyList">
        <ul class="history-file-list history-container" v-if="historyList">
          <li
            v-for="(line,index) in historyList"
            :key="index"
            class="history-file-item"
            @click="fileNameClicked(line)"
          >{{line.nameView}}</li>
        </ul>
      </el-tab-pane>
    </el-tabs>
    <div class="buttons-line" v-if="cron&&cron.id">
      <el-button
        class="el-icon-download left"
        @click="saveToFile"
        v-if="cron && selectedTab==='lastHistory'"
      >{{ $t('history.saveInFile') }}</el-button>
    </div>
  </div>
</template>

<script>
import Header from "../../components/reusable/header/Header";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      serverSelected: null,
      selectedTab: "lastHistory",
      tabKey: 0,
      modalOpen: false,
      selectedFileName: null,
    };
  },
  methods: {
    serverChanged() {
      this.$store.commit("setLoading", true);
      this.$store.commit("setHistoryList", null);
      // this.$store.commit("setLastHistory", null);
      this.$store.commit("setCron", null);
      this.$store
        .dispatch("getCron", this.serverSelected)
        .then(() => {
          this.$localStorage.set(
            "wa-history",
            JSON.stringify(this.serverSelected)
          );
          if (!this.cron.id) {
            this.$message(this.$t('history.noCronOnCurrentServer'));
            throw new Error();
          }
          return this.$store.dispatch("getLastHistory", this.cron.id);
        })
        .then(() => {
          // this.tabKey++;
          // console.log(this.lastHistory);
          return this.$store.dispatch("getHistoryList", this.cron.id);
        })
        .then(()=>{
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    tabClick() {
      // console.log(value.name);
      // this.selectedTab = value.name;
      if (this.cron && this.cron.id) {
        if (this.selectedTab === "lastHistory" && !this.lastHistory) {
          this.$store.commit("setLoading", true);
          this.$store
            .dispatch("getLastHistory", this.cron.id)
            .then(() => {
              // console.log(this.lastHistory);
              this.$store.commit("setLoading", false);
            })
            .catch(() => {
              this.$store.commit("setLoading", false);
            });
        } else if (this.selectedTab === "historyList" && !this.historyList) {
          this.$store.commit("setLoading", true);
          this.$store
            .dispatch("getHistoryList", this.cron.id)
            .then(() => {
              // console.log(this.lastHistory);
              this.$store.commit("setLoading", false);
            })
            .catch((error) => {
              // console.log(error);
              this.$store.commit('setError', error);
              this.$store.commit("setLoading", false);
            });
        }
      }
    },
    fileNameClicked(value) {
      this.selectedFileName = value.nameView;
      this.$store.commit("setLoading", true);
      this.$store
        .dispatch("getHistoryFile", {
          idCron: this.cron.id,
          logfile: value.fileName,
        })
        .then(() => {
          this.modalOpen = true;
          this.$store.commit("setLoading", false);
        })
        .catch((error) => {
          this.$store.commit("setLoading", false);
        });
    },
    saveToFile() {
      let file, fileName;
      if (this.selectedTab === "lastHistory") {
        file = this.lastHistory;
        fileName = "last_cron_save.txt";
      } else if (this.selectedTab === "historyList") {
        file = this.historyFile;
        fileName = `${this.selectedFileName}.txt`;
      }
      let href = "data:application/octet-stream," + encodeURIComponent(file);
      // let href = window.URL.createObjectURL(file);
      //создается выпадающее окно со ссылкой на файл
      var link = document.createElement("a");
      link.setAttribute("href", href);
      link.setAttribute("download", fileName);
      document.body.appendChild(link); // Required for FF

      link.click(); // This will download the data file named "my_data.csv"
    },
  },
  created() {
    let server = JSON.parse(this.$localStorage.get("wa-history"));
    if (server) {
       if (!this.getServersArray.find((s) => s.id === server)) {
        return;
      }
      this.serverSelected = server;
      this.serverChanged();
    }
  },
  computed: {
    ...mapGetters([
      "getServersArray",
      "historyList",
      "historyFile",
      "lastHistory",
      "cron",
    ]),
  },
  components: {
    myHeader: Header,
  },
};
</script>

<style scoped>
.main-history-container {
  background-color: var(--main-background);
}
.el-tabs{
  margin-left: 5px;
}
.history-container {
  height: calc(100vh - (200px + var(--header-height) + 5px));
  /* background-color: whitesmoke; */
  color: rgb(36, 36, 36);
  width: 100%;
  overflow: auto;
  scrollbar-color: grey lightgrey;
  scrollbar-width: auto;
}
.history-container::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

.history-container::-webkit-scrollbar-track {
  background-color: lightgrey;
}

.history-container::-webkit-scrollbar-thumb {
  background-color: grey;
}

.history-block {
  white-space: pre;
  font-family: "Roboto Mono", monospace;
}
.history-file-list {
  list-style: disc outside none;
  padding-left: 20px;
}
.history-file-item {
  cursor: pointer;
}
.history-file-item:hover {
  color: var(--active-color);
}
.buttons-line {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
.more-info__inner {
  height: 55vh;
  scrollbar-width: auto;
}

.more-info__inner::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
</style>